<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
    </div>
    <div class="header-content">
      <h2 langkey="phTimeCotrolDialog_Info_Items"></h2>
      <span langkey="phTimeCotrolDialog_Description"></span>
    </div>
    <ng-container *ngFor="let item of modalData.items">
      <div class="item-content">
        <div class="aspect-ratio-box">
          <div class="aspect-ratio-box-inside">
            <div class="aspect-ration-img-box">
              <img class="ya_image" [src]="item.imageUrl" alt="" />
            </div>
          </div>
        </div>
        <div class="item-info">
          <div class="item-info-wrapper">
            <div class="item-detail">
              <h2 class="title">
                {{item.label}}
              </h2>
            </div>
            <div class="item-price-detail">
              <div class="item-count">{{item.count}}</div>
              <div class="item-amount">{{(setItemPrice(item.price,item.count))}}</div>
            </div>
          </div>
          <ng-container
            *ngIf="isCurrentDaySelected(modalData.selectedDay) then currentDayTemplate else anotherDayTemplate">
          </ng-container>
          <ng-template #currentDayTemplate>
            <div class=" scheduled-info">
              <ng-container *ngIf="isOrderPossibleForCurrentDay(item.time_set,
              item.scheduled_to_hms) then timesetTemplate else selectedTimeTemplate"></ng-container>
              <ng-template #timesetTemplate> <span class="order-label"
                  langkey="phTimeCotrolDialog_Scheduled_info_Order_Time"></span>
                <span class="emphasized">{{getFormatedTime(getItemToHMS(item.time_set,
                  item.scheduled_to_hms))}}</span></ng-template>
              <ng-template #selectedTimeTemplate>
                <span [innerHTML]="noOrderPossibleForSelectedTime(modalData.selectedTime)"></span>
              </ng-template>
            </div>
          </ng-template>
          <ng-template #anotherDayTemplate>
            <div class="scheduled-info">
              <ng-container *ngIf="noOrderForAnotherDay(item.time_set,
              item.scheduled_from_hms,item.scheduled_to_hms) then timeTemplate else dayTemplate"></ng-container>
              <ng-template #timeTemplate> <span [innerHTML]="getAnotherdayLabel()"></span></ng-template>
              <ng-template #dayTemplate><span
                  langkey="phTimeCotrolDialog_No_Order_Possible_For_Selected_Day"></span></ng-template>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </div>
  <div class=" ya-dialog-action">
    <div class="ya-button-group-wrapper">
      <div class="ya-button-group-container">
        <div class="ya-button-container">
          <button mat-flat-button (click)="changeTime()">
            <span langkey="phTimeCotrolDialog_Button_Change_Time"></span>
          </button>
        </div>
        <div class="ya-button-container">
          <button mat-stroked-button (click)="removeItemFromBasket()">
            <span langkey="phTimeCotrolDialog_Button_Remove_item"> </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>